<template>
    <v-container fluid>
        <v-card class="elevation-3" :loading="loading">
            <div class="card-title">{{ $t('MunicipalitiesDataTable') }}</div>
            <v-card-title>
                <v-text-field v-model="search" clearable append-icon="mdi-magnify" :label="$t('Search')" single-line hide-details />
            </v-card-title>
            <v-data-table :search="search" :headers="headers" dense :items="result" :items-per-page="20" :footer-props="footerProps">
                <template v-slot:top>
                    <v-btn small class="ma-4 white--text" tile color="primary" @click="open()">
                        {{ $t('Add') }} <v-icon small class="ms-2">mdi-plus</v-icon>
                    </v-btn>
                </template>
                <!--<template v-slot:[`item.surveyId`]="{ item }">
                    {{item.surveyId?surveys.filter(x=>x.id == item.surveyId)[0].nameAr:''}}
                </template>
                <template v-slot:[`item.municipalityId`]="{ item }">
                    {{municipalities.filter(x=>x.id == item.municipalityId).length>0?municipalities.filter(x=>x.id == item.municipalityId)[0].name:''}}
                </template>-->
                
                <template v-slot:[`item.options`]="{ item }">
                    <v-icon color="primary" class="ms-3" @click="editItem(item)"> mdi-pen</v-icon>
                    <v-icon color="error" class="ms-3" @click="deleteItem(item.id)">mdi-trash-can-outline</v-icon>
                </template>
            </v-data-table>
            <v-form ref="dataForm" v-model="valid" lazy-validation>
                <CommonDialog v-model="dialog" :fullscreen="false" width="500" :title="title" show-action-toolbar>
                    <v-container>
                        <v-row>
                            <v-col cols="12">
                                <v-text-field v-model="MunicipalitiesData.quarter" :label="$t('Quarter')" clearable outlined :rules="nameRules" required />
                            </v-col>
                            <v-col cols="12">
                                <v-text-field v-model="MunicipalitiesData.year" :label="$t('Year')" clearable outlined :rules="nameRules" required />
                            </v-col>
                            <v-col cols="12">
                                <v-text-field v-model="MunicipalitiesData.percentage" :label="$t('Percentage')" clearable outlined :rules="nameRules" required />
                            </v-col>
                            <v-col cols="12">
                                <v-select v-model="MunicipalitiesData.surveyId" :items="surveys" :label="$t('Survey')" item-text="nameAr" item-value="id" clearable outlined required>
                                    <template v-slot:item="{ item }">
                                        {{ item.id }} -  {{ isArabicLanguage ? item.nameAr : item.nameEn }}
                                    </template>
                                </v-select>
                            </v-col>
                            <v-col cols="12">
                                <v-select v-model="MunicipalitiesData.municipalityId" :items="municipalities" :label="$t('Municipality')" item-text="name" item-value="id" clearable outlined required></v-select>
                            </v-col>
                            
                        </v-row>
                    </v-container>

                    <template v-slot:actions>
                        <v-btn v-if="!edit" color="primary" class="white--text" tile :disabled="loading || !MunicipalitiesData.surveyId || !MunicipalitiesData.quarter || ! MunicipalitiesData.year || !MunicipalitiesData.percentage || !MunicipalitiesData.municipalityId" small @click="save()">
                            {{ $t("Add") }}
                        </v-btn>
                        <v-btn v-if="edit" color="primary" class="white--text" tile :disabled="loading || !MunicipalitiesData.surveyId || !MunicipalitiesData.quarter || ! MunicipalitiesData.year || !MunicipalitiesData.percentage || !MunicipalitiesData.municipalityId" small @click="update()">
                            {{ $t("Update") }}
                        </v-btn>
                        <v-btn color="error" class="white--text" tile :disabled="loading" small @click="dialog = false; reset()">
                            {{ $t("Cancel") }}
                        </v-btn>
                    </template>
                </CommonDialog>
            </v-form>
        </v-card>
    </v-container>
</template>

<script>
    import CommonDialog from '@/components/controls/CommonDialog'
    import StructuresService from '@/services/StructuresService'
    import MunicipalitiesDataService from '@/services/MunicipalitiesDataService.js'
    import SurveyService from '@/services/SurveyService'
    import { AnalyticsTypes } from '@/helpers/constants/enumerations.js'

    export default {
        components: {
            CommonDialog
        },

        data() {
            return {
                title: '',
                search: '',
                valid: true,
                loading: false,
                dialog: false,
                surveys:[],
                edit: false,
                selectedItemId: null,
                result: [],
                municipalities:[],
                filterquestions: [],
                csatoptions: [],
                allcsatoptions: [],
                allfilterquestions: [],
                headers: [
                    { text: this.$t('Quarter'), value: 'quarter' },
                    { text: this.$t('Year'), value: 'year' },
                    { text: this.$t('Percentage'), value: 'percentage' },
                    { text: this.$t('Survey'), value: 'surveyName' },    
                    { text: this.$t('Municipality'), value: 'municipalityName' },     
                    { text: this.$t('Options'), value: 'options', width: '8%' },
                    
                ],
                nameRules: [
                    v => !!v || this.$t('RequiredField')
                ],
                footerProps: {
                    'items-per-page-options': [20, 50, 100],
                    'disable-pagination': false
                },
                MunicipalitiesData: {
                    quarter: null,
                    year: null,
                    count: null,
                    surveyId:null,
                    municipalityId: null,
                    surveyName:''
                }
            }
        },

        async created() {

            await this.listSurveys()
            await this.listMunicipalities()
            this.loadData()
        },

        methods: {
            async listMunicipalities() {
                try { 
                    var res = await StructuresService.listMunicipalities()
                    if (res.data) {
                        for (var i = 0; i < res.data.length;i++)
                        {
                            var item = res.data[i]
                            this.municipalities.push({
                                id: item.id,
                                name: item.name
                            })
                        }
                        
                    }
                }
                catch{
                    this.$root.$notification(this.$t('ErrorOccurred'), 'error')
                }
                this.loading = false
            },
            async listSurveys() {
                this.loading = true
                try {
                    var res = await SurveyService.listSurveys(false)
                    this.surveys = res.data
                }
                catch {
                    this.$root.$notification(this.$t('ErrorOccurred'), 'error')
                }
                    this.loading = false
            },
            loadData() {
                this.loading = true
                MunicipalitiesDataService.listData().then((res) => {
                    if (res.data) {
                        this.result = res.data
                        for (var i = 0; i < this.result.length;i++)
                        {
                            var survey = this.surveys.filter(x => x.id == this.result[i].surveyId)
                            this.result[i].surveyName = survey.length>0?survey[0].id + ' - ' + survey[0].nameAr:''
                            this.result[i].municipalityName = this.municipalities.filter(x => x.id == this.result[i].municipalityId).length > 0 ? this.municipalities.filter(x => x.id == this.result[i].municipalityId)[0].name : ''
                        }
                    }
                }).catch((err) => {
                    this.$root.$notification(err.toString(), 'error')
                }).finally(() => {
                    this.loading = false
                })
            },

            save() {
                if (this.$refs.dataForm.validate()) {
                    MunicipalitiesDataService.addData(this.MunicipalitiesData).then((res) => {
                        this.loadData()
                        this.reset()
                        this.$refs.dataForm.resetValidation()
                    }).catch(() => {
                        this.$root.$notification(this.$t('ErrorOccurred'), 'error')
                    }).finally(() => {
                        this.loading = false
                        this.dialog = false
                    })
                }
            },

            update() {
                if (this.$refs.dataForm.validate()) {
                    MunicipalitiesDataService.updateData(this.selectedItemId, this.MunicipalitiesData).then((res) => {
                        this.dialog = false
                        this.loadData()
                        this.reset()
                    }).catch(() => {
                        this.$root.$notification(this.$t('ErrorOccurred'), 'error')
                    }).finally(() => {
                        this.loading = false
                        this.dialog = false
                    })
                }
            },

            async deleteItem(id) {
                if (await this.$root.$confirm(this.$t('Delete'), this.$t('ConfirmDelete'))) {
                    this.loading = true
                    MunicipalitiesDataService.deleteData(id)
                        .then(() => {
                            this.loadData()
                        })
                        .catch(() => {
                            this.$root.$notification(this.$t('ErrorOccurred'), 'error')
                        }).finally(() => this.loading = false)
                }
            },

            reset() {
                this.selectedItemId = null
                this.MunicipalitiesData = {
                    quarter: null,
                    year: null,
                    count: null,
                    surveyId: null,
                    municipalityId: null
                }
                this.csatoptions = []
                this.filterquestions = []
            },

            open() {
                this.reset()
                this.edit = false
                this.selectedItemId = null
                this.$refs.dataForm.resetValidation()
                this.title = this.$t('Add')
                this.dialog = true
            },

            editItem(item) {
                this.edit = true
                this.MunicipalitiesData = item
                this.selectedItemId = item.id
                this.title = this.$t('Edit')
                this.dialog = true
            },
        },
    }
</script>

<style>
</style>